export const NOTIFICATION_SCOPES = ["off", "involved", "all"] as const
export type NotificationScope = (typeof NOTIFICATION_SCOPES)[number]

export const NOTIFICATION_REASONS = [
	"assigned",
	"mentioned",
	"subscribed",
	"topic",
	"workspace",
	"admin",
	"initiator",
] as const
export type NotificationReason = (typeof NOTIFICATION_REASONS)[number]

export const NOTIFICATION_ENTITY_TYPES = [
	"thread",
	"company",
	"tag",
	"view",
	"issue",
	"project",
	"docsArticle",
	"workspace",
] as const
export type NotificationEntityType = (typeof NOTIFICATION_ENTITY_TYPES)[number]

export const SUBSCRIBABLE_ENTITY_TYPES = [
	"thread",
	"company",
	"tag",
	"view",
	"issue",
	"project",
	"docsArticle",
] as const
export type SubscribableEntityType = (typeof SUBSCRIBABLE_ENTITY_TYPES)[number]

export const NOTIFICATION_SUBSCRIPTION_SOURCES = [
	"manual",
	"creator",
	"assignee",
	"mentioned",
	"commented",
	"replied",
	"owner",
	"added",
] as const
export type NotificationSubscriptionSource =
	(typeof NOTIFICATION_SUBSCRIPTION_SOURCES)[number]

export const NOTIFICATION_CATEGORIES = [
	"threads",
	"comments",
	"subscriptions",
	"workspace",
] as const
export type NotificationCategory = (typeof NOTIFICATION_CATEGORIES)[number]

/** Typed route, not a URL, so web, mobile and push each map it to their own navigation. */
export type NotificationTarget =
	| { kind: "thread"; threadId: string }
	| { kind: "issue"; issueId: string }
	| { kind: "project"; projectId: string }
	| { kind: "docsArticle"; articleId: string }
	| { kind: "docsProposals" }
	| { kind: "settings"; path: string }
	| { kind: "none" }

export interface NotificationContent {
	title: string
	body?: string
	target: NotificationTarget
}

/** Stored in Notification.payload: the rendered snapshot plus the type's own fields. */
export type StoredNotificationPayload = NotificationContent &
	Record<string, unknown>

export type MembershipRoleName = "ADMIN" | "USER" | "VIEWER"
